import { Box, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldPath,
  useForm,
  UseFormRegister,
} from 'react-hook-form';

type FormValues = {
  fieldSimple?: string;
  fieldDouble?: string;
  fieldDouble2?: string;
};

const defaultValues: FormValues = {
  fieldSimple: 'john',
  fieldDouble: 'AA##BB',
  fieldDouble2: 'CC##11',
};

export function LabFieldWith2Input() {
  const [watchValues, setWatchValues] = useState<FormValues | undefined>(
    undefined,
  );

  const { register, handleSubmit, watch, control } = useForm<FormValues>({
    defaultValues: defaultValues,
  });

  useEffect(() => {
    const subscription = watch((data) => setWatchValues(data));
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = (data: FormValues) => {
    console.log('✅submit', data);
  };

  return (
    <Stack spacing={3} sx={{ mb: 2 }}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        register={register}
        control={control}
      />
      <WatchValues values={watchValues} />
    </Stack>
  );
}

function Form({
  onSubmit,
  register,
  control,
}: {
  onSubmit: () => void;
  register: UseFormRegister<FormValues>;
  control: Control<FormValues, unknown>;
}) {
  return (
    <Box>
      <Typography sx={{ fontSize: '1.5rem', color: '#45AA32' }}>
        Form :
      </Typography>
      <form onSubmit={onSubmit}>
        <Stack spacing={3} alignItems={'start'}>
          <Box>
            <Typography>champ text simple</Typography>
            <input type="text" {...register('fieldSimple')} />
          </Box>
          <Box>
            <Typography>champ text -double-</Typography>
            {/* <CustomInputTwoTextField {...register('fieldDouble')} /> */}
          </Box>
          <Box>
            <Typography>champ text -double- 2</Typography>
            <Controller
              control={control}
              name={'fieldDouble2'}
              // @ts-ignore
              render={ControledCustomDoubleInput}
            />
          </Box>
          <Box>
            <button type="submit">submit</button>
          </Box>
        </Stack>
      </form>
    </Box>
  );
}

function WatchValues({ values }: { values: FormValues | undefined }) {
  return (
    <Box>
      <Typography sx={{ fontSize: '1.5rem', color: '#45AA32' }}>
        Watch values :
      </Typography>
      {JSON.stringify(values, null, 2)}
    </Box>
  );
}

// option #1 :
// register: (name: string, RegisterOptions?) => ({ onChange, onBlur, name, ref })
/*
Coder un compo qui recoit gère les props suviantes :
   required: Message | ValidationRule<boolean>;
    min: ValidationRule<number | string>;
    max: ValidationRule<number | string>;
    maxLength: ValidationRule<number>;
    minLength: ValidationRule<number>;
    validate: Validate<FieldPathValue<TFieldValues, TFieldName>, TFieldValues> | Record<string, Validate<FieldPathValue<TFieldValues, TFieldName>, TFieldValues>>;
    value: FieldPathValue<TFieldValues, TFieldName>;
    setValueAs: (value: any) => any;
    shouldUnregister?: boolean;
    onChange?: (event: any) => void;
    onBlur?: (event: any) => void;
    disabled: boolean;
    deps: InternalFieldName | InternalFieldName[];

exemple ici: https://learnersbucket.com/examples/react/create-input-component-in-react/

autre exemple en regardant les lib ui :
https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/src/form-control/use-form-control.ts#L25
*/

// @ts-ignore

// eslint-disable-next-line unused-imports/no-unused-vars
function CustomInputTwoTextField(props) {
  // console.log('props received', props);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const { onChange, onBlue, name } = props;

  const onField1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    // console.log('f1 change', e);
    onChange(e);
  };
  return (
    <Stack>
      <Stack direction={'row'} spacing={1}>
        <input onChange={onField1Change} />
        <Typography>XX</Typography>
        <input />
      </Stack>
    </Stack>
  );
}

// options #2 : en utilisant un Controler
const ControledCustomDoubleInput = ({
  field,
}: {
  field: ControllerRenderProps<FormValues, FieldPath<FormValues>>; // typage pas sur...
}) => {
  const { onChange, onBlur, value } = field;

  let valueInput1 = '';
  let valueInput2 = '';
  const splits = value?.split('##');
  if (splits) {
    valueInput1 = splits[0];
    valueInput2 = splits[1];
  }

  const onChangeInput1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = joinValues(e.currentTarget.value, valueInput2);
    onChange(newValue);
  };

  const onChangeInput2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = joinValues(valueInput1, e.currentTarget.value);
    onChange(newValue);
  };

  const joinValues = (value1: string, value2: string) => {
    return `${value1}##${value2}`;
  };

  return (
    <Stack>
      <Stack direction={'row'} spacing={1}>
        <input value={valueInput1} onChange={onChangeInput1} onBlur={onBlur} />
        <Typography>XX</Typography>
        <input value={valueInput2} onChange={onChangeInput2} onBlur={onBlur} />
      </Stack>
    </Stack>
  );
};

// on pourrait ajouter le onBlur
// onBlur={onBlur} // notify when input is touched/blur

// function CustomInputTwoTextField2({
//   name,
//   control,
// }: {
//   name: keyof FormValues;
//   control: Control<FormValues, unknown>;
// }) {
//   return <Controller control={control} name={name} render={renderInput} />;
// }

// on pourrait utiliser d'autres props de field et fieldState et formState en plus
// formState,  // fieldState,
// fieldState: ControllerFieldState;
// formState: UseFormStateReturn<FormValues>;

// le formState inclus le field error
// exemple https://dev.to/apoorvacg/react-hook-form-with-controllers-16k3
